import UserAccounts from "./UserAccounts-container";

/**
 * Export the top level component UserAccounts-container
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */
export default UserAccounts;
